export const DUMMY_DATA = [
  {
    date: "2026-05-18",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-a-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-a-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-a-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-a-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-205",
                    title: "Evergreen's yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T07:00:00+05:00",
                    end: "2025-07-28T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-206",
                    title: "Oak Crest Apartments",
                    status: "completed",
                    startTime: "7:42 AM",
                    endTime: "8:13 AM",
                    address: "3100 N Haskell Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20568",
                    start: "2025-07-28T07:42:00+05:00",
                    end: "2025-07-28T08:13:00+05:00",
                    origin: {
                      lat: 32.80968717938662,
                      lng: -96.79502553992131,
                    },
                    drive_time: "12",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-207",
                    title: "Maplewood Offices",
                    status: "completed",
                    startTime: "8:24 AM",
                    endTime: "8:49 AM",
                    address: "3936 Travis St, Dallas, TX",
                    contract: "Maintenance Agreement 20569",
                    start: "2025-07-28T08:24:00+05:00",
                    end: "2025-07-28T08:49:00+05:00",
                    origin: {
                      lat: 32.812420318228995,
                      lng: -96.79604852067472,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-208",
                    title: "Lakeside Retail Center",
                    status: "completed",
                    startTime: "8:59 AM",
                    endTime: "9:31 AM",
                    address: "4034a Buena Vista St, Dallas, TX",
                    contract: "Maintenance Agreement 20570",
                    start: "2025-07-28T08:59:00+05:00",
                    end: "2025-07-28T09:31:00+05:00",
                    origin: {
                      lat: 32.81436324549151,
                      lng: -96.79627887076978,
                    },
                    drive_time: "10",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-209",
                    title: "Pine Valley Townhomes",
                    status: "completed",
                    startTime: "9:39 AM",
                    endTime: "10:04 AM",
                    address: "4007 Stonebridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20571",
                    start: "2025-07-28T09:39:00+05:00",
                    end: "2025-07-28T10:04:00+05:00",
                    origin: {
                      lat: 32.81636202011015,
                      lng: -96.79676832281925,
                    },
                    drive_time: "8",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-210",
                    title: "Willowbrook Condo",
                    status: "completed",
                    startTime: "10:17 AM",
                    endTime: "10:42 AM",
                    address: "4136 Cole Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20572",
                    start: "2025-07-28T10:17:00+05:00",
                    end: "2025-07-28T10:42:00+05:00",
                    origin: {
                      lat: 32.81564916786807,
                      lng: -96.79247714923689,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-211",
                    title: "Elm Park Plaza",
                    status: "completed",
                    startTime: "10:51 AM",
                    endTime: "11:31 AM",
                    address: "4061 N Central Expy, Dallas, TX",
                    contract: "Maintenance Agreement 20573",
                    start: "2025-07-28T10:51:00+05:00",
                    end: "2025-07-28T11:31:00+05:00",
                    origin: {
                      lat: 32.81354908694805,
                      lng: -96.7912577014335,
                    },
                    drive_time: "9",
                    durationMinutes: 40,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-212",
                    title: "Cedar Ridge Village",
                    status: "completed",
                    startTime: "11:41 AM",
                    endTime: "12:14 PM",
                    address: "4114 N Central Expy, Dallas, TX",
                    contract: "Maintenance Agreement 20574",
                    start: "2025-07-28T11:41:00+05:00",
                    end: "2025-07-28T12:14:00+05:00",
                    origin: {
                      lat: 32.81313047201152,
                      lng: -96.7890222835907,
                    },
                    drive_time: "10",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-213",
                    title: "Birchwood Medical",
                    status: "completed",
                    startTime: "12:28 PM",
                    endTime: "12:53 PM",
                    address: "2802 N Carroll Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20575",
                    start: "2025-07-28T12:28:00+05:00",
                    end: "2025-07-28T12:53:00+05:00",
                    origin: {
                      lat: 32.811918200755336,
                      lng: -96.78875237948533,
                    },
                    drive_time: "14",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-214",
                    title: "Dogwood Business Park",
                    status: "completed",
                    startTime: "1:05 PM",
                    endTime: "1:30 PM",
                    address:
                      "Birchwood Apartment Homes, 4829 Coles Manor Pl, Dallas, TX",
                    contract: "Maintenance Agreement 20576",
                    start: "2025-07-28T13:05:00+05:00",
                    end: "2025-07-28T13:30:00+05:00",
                    origin: {
                      lat: 32.812917201451604,
                      lng: -96.78566615676915,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-215",
                    title: "Magnolia Senior Living",
                    status: "completed",
                    startTime: "1:37 PM",
                    endTime: "2:09 PM",
                    address: "4319 Belmont Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20577",
                    start: "2025-07-28T13:37:00+05:00",
                    end: "2025-07-28T14:09:00+05:00",
                    origin: {
                      lat: 32.808547324041506,
                      lng: -96.78931852971077,
                    },
                    drive_time: "7",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-216",
                    title: "Aspen Heights School",
                    status: "completed",
                    startTime: "2:19 PM",
                    endTime: "2:44 PM",
                    address: "2409 N Henderson Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20578",
                    start: "2025-07-28T14:19:00+05:00",
                    end: "2025-07-28T14:44:00+05:00",
                    origin: {
                      lat: 32.815060654789114,
                      lng: -96.77892301199331,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-217",
                    title: "Sycamore Fitness Center",
                    status: "completed",
                    startTime: "2:57 PM",
                    endTime: "3:23 PM",
                    address: "7 McKinney Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20579",
                    start: "2025-07-28T14:57:00+05:00",
                    end: "2025-07-28T15:23:00+05:00",
                    origin: {
                      lat: 32.82044107805568,
                      lng: -96.78900343145571,
                    },
                    drive_time: "13",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-218",
                    title: "Juniper Villas",
                    status: "completed",
                    startTime: "3:34 PM",
                    endTime: "3:59 PM",
                    address: "3504 Overbrook Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20580",
                    start: "2025-07-28T15:34:00+05:00",
                    end: "2025-07-28T15:59:00+05:00",
                    origin: {
                      lat: 32.82045391775728,
                      lng: -96.79438485741689,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-219",
                    title: "Evergreen's yard",
                    status: "completed",
                    startTime: "3:59 PM",
                    endTime: "4:29 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-28T15:59:00+05:00",
                    end: "2025-07-28T16:29:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  {
    date: "2026-05-19",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-220",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T07:00:00+05:00",
                    end: "2025-07-29T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "8",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-221",
                    title: "Oakdale Senior Center",
                    status: "completed",
                    startTime: "7:40 AM",
                    endTime: "8:15 AM",
                    address: "5637 Hunters Bend Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20584",
                    start: "2025-07-29T07:40:00+05:00",
                    end: "2025-07-29T08:15:00+05:00",
                    origin: {
                      lat: 32.65537421687229,
                      lng: -96.97332544996381,
                    },
                    drive_time: "10",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-222",
                    title: "Brookstone Plaza",
                    status: "completed",
                    startTime: "8:26 AM",
                    endTime: "8:51 AM",
                    address: "5621 Bandit Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20585",
                    start: "2025-07-29T08:26:00+05:00",
                    end: "2025-07-29T08:51:00+05:00",
                    origin: {
                      lat: 32.65793132845956,
                      lng: -96.96997676403906,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-223",
                    title: "Elm Creek HOA",
                    status: "completed",
                    startTime: "8:57 AM",
                    endTime: "9:30 AM",
                    address: "5666 Mountain Hollow Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20586",
                    start: "2025-07-29T08:57:00+05:00",
                    end: "2025-07-29T09:30:00+05:00",
                    origin: {
                      lat: 32.65727746412962,
                      lng: -96.96548980363775,
                    },
                    drive_time: "6",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-224",
                    title: "Highland Commons",
                    status: "completed",
                    startTime: "9:37 AM",
                    endTime: "10:05 AM",
                    address: "5680 Centeridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20587",
                    start: "2025-07-29T09:37:00+05:00",
                    end: "2025-07-29T10:05:00+05:00",
                    origin: {
                      lat: 32.65848800584531,
                      lng: -96.96247565034557,
                    },
                    drive_time: "7",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-225",
                    title: "Briarwood Medical",
                    status: "completed",
                    startTime: "10:18 AM",
                    endTime: "10:43 AM",
                    address: "7917 Vista Hill Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20588",
                    start: "2025-07-29T10:18:00+05:00",
                    end: "2025-07-29T10:43:00+05:00",
                    origin: {
                      lat: 32.65588730116591,
                      lng: -96.96155785883717,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-226",
                    title: "Lakeview Apartments",
                    status: "completed",
                    startTime: "10:52 AM",
                    endTime: "11:23 AM",
                    address: "8635-8799 Granville Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20589",
                    start: "2025-07-29T10:52:00+05:00",
                    end: "2025-07-29T11:23:00+05:00",
                    origin: {
                      lat: 32.657329702530106,
                      lng: -96.95182588465576,
                    },
                    drive_time: "9",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-227",
                    title: "Whispering Pines Park",
                    status: "completed",
                    startTime: "11:33 AM",
                    endTime: "11:58 AM",
                    address: "8441 Clark Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20590",
                    start: "2025-07-29T11:33:00+05:00",
                    end: "2025-07-29T11:58:00+05:00",
                    origin: {
                      lat: 32.66098299324898,
                      lng: -96.94440557908295,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-228",
                    title: "Sunset Commercial Lot",
                    status: "completed",
                    startTime: "12:04 PM",
                    endTime: "12:29 PM",
                    address: "61407 W Ridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20591",
                    start: "2025-07-29T12:04:00+05:00",
                    end: "2025-07-29T12:29:00+05:00",
                    origin: {
                      lat: 32.656571503312556,
                      lng: -96.94134323823776,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-229",
                    title: "Orchard Villas",
                    status: "completed",
                    startTime: "12:41 PM",
                    endTime: "1:06 PM",
                    address: "6823 Cedar Forest Trail, Dallas, TX",
                    contract: "Maintenance Agreement 20592",
                    start: "2025-07-29T12:41:00+05:00",
                    end: "2025-07-29T13:06:00+05:00",
                    origin: {
                      lat: 32.664738578647075,
                      lng: -96.93503995031634,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-230",
                    title: "Linden Estates",
                    status: "completed",
                    startTime: "1:19 PM",
                    endTime: "1:49 PM",
                    address: "6927 Clarkridge Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20593",
                    start: "2025-07-29T13:19:00+05:00",
                    end: "2025-07-29T13:49:00+05:00",
                    origin: {
                      lat: 32.66781678212907,
                      lng: -96.9434105721135,
                    },
                    drive_time: "13",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-231",
                    title: "Redbud Office Center",
                    status: "completed",
                    startTime: "2:03 PM",
                    endTime: "2:35 PM",
                    address: "8303 Timberbrook Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20594",
                    start: "2025-07-29T14:03:00+05:00",
                    end: "2025-07-29T14:35:00+05:00",
                    origin: {
                      lat: 32.66542401234956,
                      lng: -96.95120340724914,
                    },
                    drive_time: "14",
                    durationMinutes: 32,
                  },
                  {
                    id: "landscape_maintenance-visit-232",
                    title: "Windsor Hill Retail",
                    status: "completed",
                    startTime: "2:48 PM",
                    endTime: "3:13 PM",
                    address: "6640 Legters Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20595",
                    start: "2025-07-29T14:48:00+05:00",
                    end: "2025-07-29T15:13:00+05:00",
                    origin: {
                      lat: 32.667104262352105,
                      lng: -96.95313191395635,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-233",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "3:13 PM",
                    endTime: "3:43 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-29T15:13:00+05:00",
                    end: "2025-07-29T15:43:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  {
    date: "2026-05-20",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-234",
                    title: "Evergreen's Yard",
                    status: "completed",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T07:00:00+05:00",
                    end: "2025-07-30T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "8",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-235",
                    title: "Shady Creek Offices",
                    status: "completed",
                    startTime: "7:37 AM",
                    endTime: "8:14 AM",
                    address: "4614 Kolloch Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20596",
                    start: "2025-07-30T07:37:00+05:00",
                    end: "2025-07-30T08:14:00+05:00",
                    origin: {
                      lat: 32.70505404900747,
                      lng: -96.75743760439987,
                    },
                    drive_time: "7",
                    durationMinutes: 37,
                  },
                  {
                    id: "landscape_maintenance-visit-236",
                    title: "Ridgepoint Plaza",
                    status: "completed",
                    startTime: "8:27 AM",
                    endTime: "8:52 AM",
                    address: "4420 Seay Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20597",
                    start: "2025-07-30T08:27:00+05:00",
                    end: "2025-07-30T08:52:00+05:00",
                    origin: {
                      lat: 32.70708247927941,
                      lng: -96.7652142,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-237",
                    title: "Greenville Commons",
                    status: "completed",
                    startTime: "9:00 AM",
                    endTime: "9:35 AM",
                    address: "3617 Humphrey Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20598",
                    start: "2025-07-30T09:00:00+05:00",
                    end: "2025-07-30T09:35:00+05:00",
                    origin: {
                      lat: 32.718464624263355,
                      lng: -96.76801031405128,
                    },
                    drive_time: "8",
                    durationMinutes: 35,
                  },
                  {
                    id: "landscape_maintenance-visit-238",
                    title: "Stonegate HOA",
                    status: "completed",
                    startTime: "9:41 AM",
                    endTime: "10:10 AM",
                    address: "3815 Cotton Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20599",
                    start: "2025-07-30T09:41:00+05:00",
                    end: "2025-07-30T10:10:00+05:00",
                    origin: {
                      lat: 32.72002758596667,
                      lng: -96.76145415406101,
                    },
                    drive_time: "6",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-239",
                    title: "Windsong Apartments",
                    status: "confirmation_pending",
                    startTime: "10:20 AM",
                    endTime: "10:53 AM",
                    address: "7921-7999 Carbondale St, Dallas, TX",
                    contract: "Maintenance Agreement 20600",
                    start: "2025-07-30T10:20:00+05:00",
                    end: "2025-07-30T10:53:00+05:00",
                    origin: {
                      lat: 32.71376474617464,
                      lng: -96.74906086416941,
                    },
                    drive_time: "10",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-240",
                    title: "Parkside Medical",
                    status: "confirmation_pending",
                    startTime: "11:05 AM",
                    endTime: "11:30 AM",
                    address: "4754 Zealand St, Dallas, TX",
                    contract: "Maintenance Agreement 20601",
                    start: "2025-07-30T11:05:00+05:00",
                    end: "2025-07-30T11:30:00+05:00",
                    origin: {
                      lat: 32.714879983513825,
                      lng: -96.74307330592717,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-241",
                    title: "Fox Hollow Center",
                    status: "in_progress",
                    startTime: "11:37 AM",
                    endTime: "12:06 PM",
                    address: "4518 Cherbourg St, Dallas, TX",
                    contract: "Maintenance Agreement 20602",
                    start: "2025-07-30T11:37:00+05:00",
                    end: "2025-07-30T12:06:00+05:00",
                    origin: {
                      lat: 32.70755648337157,
                      lng: -96.74501779551147,
                    },
                    drive_time: "7",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-242",
                    title: "Rosefield Retail",
                    status: "scheduled",
                    startTime: "12:12 PM",
                    endTime: "12:37 PM",
                    address: "Pilgrim Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20603",
                    start: "2025-07-30T12:12:00+05:00",
                    end: "2025-07-30T12:37:00+05:00",
                    origin: {
                      lat: 32.743060479382805,
                      lng: -96.75275536918186,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-243",
                    title: "Trailbend Estates",
                    status: "scheduled",
                    startTime: "12:50 PM",
                    endTime: "1:15 PM",
                    address: "2433 Scott St, Dallas, TX",
                    contract: "Maintenance Agreement 20604",
                    start: "2025-07-30T12:50:00+05:00",
                    end: "2025-07-30T13:15:00+05:00",
                    origin: {
                      lat: 32.743493138197465,
                      lng: -96.75446649462363,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-244",
                    title: "Summit Commercial Park",
                    status: "scheduled",
                    startTime: "1:24 PM",
                    endTime: "1:57 PM",
                    address: "5701-5799 Sunday St, Dallas, TX",
                    contract: "Maintenance Agreement 20605",
                    start: "2025-07-30T13:24:00+05:00",
                    end: "2025-07-30T13:57:00+05:00",
                    origin: {
                      lat: 32.743121468155636,
                      lng: -96.756029891658,
                    },
                    drive_time: "9",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-245",
                    title: "Northwood Condos",
                    status: "scheduled",
                    startTime: "2:07 PM",
                    endTime: "2:32 PM",
                    address: "2313 Bethurum Ave, Dallas, TX",
                    contract: "Maintenance Agreement 20606",
                    start: "2025-07-30T14:07:00+05:00",
                    end: "2025-07-30T14:32:00+05:00",
                    origin: {
                      lat: 32.74392955029714,
                      lng: -96.75610036468888,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-246",
                    title: "Vantage Point Center",
                    status: "scheduled",
                    startTime: "2:43 PM",
                    endTime: "3:08 PM",
                    address: "2220 Hooper St, Dallas, TX",
                    contract: "Maintenance Agreement 20607",
                    start: "2025-07-30T14:43:00+05:00",
                    end: "2025-07-30T15:08:00+05:00",
                    origin: {
                      lat: 32.745206478954486,
                      lng: -96.75726338925523,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-247",
                    title: "Lakehill Business Hub",
                    status: "scheduled",
                    startTime: "3:16 PM",
                    endTime: "3:45 PM",
                    address: "1699-1601 Faye St, Dallas, TX",
                    contract: "Maintenance Agreement 20608",
                    start: "2025-07-30T15:16:00+05:00",
                    end: "2025-07-30T15:45:00+05:00",
                    origin: {
                      lat: 32.74442339819566,
                      lng: -96.7585746070007,
                    },
                    drive_time: "8",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-248",
                    title: "Hillside Villas",
                    status: "scheduled",
                    startTime: "3:59 PM",
                    endTime: "4:24 PM",
                    address: "2483-2301 Anderson St, Dallas, TX",
                    contract: "Maintenance Agreement 20609",
                    start: "2025-07-30T15:59:00+05:00",
                    end: "2025-07-30T16:24:00+05:00",
                    origin: {
                      lat: 32.74571679880741,
                      lng: -96.75551282897112,
                    },
                    drive_time: "14",
                    durationMinutes: 25,
                  },
                  // {
                  //   id: "landscape_maintenance-visit-249",
                  //   title: "Skyline Estates",
                  //   status: "scheduled",
                  //   startTime: "4:31 PM",
                  //   endTime: "5:17 PM",
                  //   address: "72520-2598 Lowery St, Dallas, TX",
                  //   contract: "Maintenance Agreement 20610",
                  //   start: "2025-07-30T16:31:00+05:00",
                  //   end: "2025-07-30T17:17:00+05:00",
                  //   origin: {
                  //     lat: 32.74594196377146,
                  //     lng: -96.75423417961444,
                  //   },
                  //   drive_time: "7",
                  //   durationMinutes: 46,
                  // },
                  {
                    id: "landscape_maintenance-visit-250",
                    title: "Brookfield Shops",
                    status: "scheduled",
                    startTime: "5:26 PM",
                    endTime: "5:56 PM",
                    address: "92233 Macon St, Dallas, TX",
                    contract: "Maintenance Agreement 20611",
                    start: "2025-07-30T17:26:00+05:00",
                    end: "2025-07-30T17:56:00+05:00",
                    origin: {
                      lat: 32.747270379735575,
                      lng: -96.7578350620327,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-251",
                    title: "Wheatland Townhomes",
                    status: "scheduled",
                    startTime: "6:05 PM",
                    endTime: "6:35 PM",
                    address: "3420-3612 Hancock St, Dallas, TX",
                    contract: "Maintenance Agreement 20612",
                    start: "2025-07-30T18:05:00+05:00",
                    end: "2025-07-30T18:35:00+05:00",
                    origin: {
                      lat: 32.76149199984842,
                      lng: -96.74355618650819,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-252",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "6:35 PM",
                    endTime: "7:05 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-30T18:35:00+05:00",
                    end: "2025-07-30T19:05:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  {
    date: "2026-05-21",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-253",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T07:00:00+05:00",
                    end: "2025-07-31T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-254",
                    title: "Elm Grove Condos",
                    status: "scheduled",
                    startTime: "7:42 AM",
                    endTime: "8:10 AM",
                    address: "121234 Templecliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20613",
                    start: "2025-07-31T07:42:00+05:00",
                    end: "2025-07-31T08:10:00+05:00",
                    origin: {
                      lat: 32.73382673768448,
                      lng: -96.7039446,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-255",
                    title: "Lakewood Plaza",
                    status: "scheduled",
                    startTime: "8:20 AM",
                    endTime: "8:45 AM",
                    address: "101515 N Jim Miller Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20614",
                    start: "2025-07-31T08:20:00+05:00",
                    end: "2025-07-31T08:45:00+05:00",
                    origin: {
                      lat: 32.73939495440909,
                      lng: -96.70192221780633,
                    },
                    drive_time: "10",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-256",
                    title: "Fair Oaks Retail",
                    status: "scheduled",
                    startTime: "8:54 AM",
                    endTime: "9:24 AM",
                    address: "96937 Umphress Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20615",
                    start: "2025-07-31T08:54:00+05:00",
                    end: "2025-07-31T09:24:00+05:00",
                    origin: {
                      lat: 32.74174537738961,
                      lng: -96.70189263337386,
                    },
                    drive_time: "9",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-257",
                    title: "The Overlook HOA",
                    status: "scheduled",
                    startTime: "9:37 AM",
                    endTime: "10:02 AM",
                    address: "131703 Rocky Pl Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20616",
                    start: "2025-07-31T09:37:00+05:00",
                    end: "2025-07-31T10:02:00+05:00",
                    origin: {
                      lat: 32.74175237157451,
                      lng: -96.70101130412979,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-258",
                    title: "Brookstone Suites",
                    status: "scheduled",
                    startTime: "10:09 AM",
                    endTime: "10:34 AM",
                    address: "76902 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20617",
                    start: "2025-07-31T10:09:00+05:00",
                    end: "2025-07-31T10:34:00+05:00",
                    origin: {
                      lat: 32.742739134759965,
                      lng: -96.70301784305627,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-259",
                    title: "Hilltop Center",
                    status: "scheduled",
                    startTime: "10:42 AM",
                    endTime: "11:13 AM",
                    address: "86803 Woodhill Rd, Dallas, TX",
                    contract: "Maintenance Agreement 20618",
                    start: "2025-07-31T10:42:00+05:00",
                    end: "2025-07-31T11:13:00+05:00",
                    origin: {
                      lat: 32.74326442753792,
                      lng: -96.70409202785368,
                    },
                    drive_time: "8",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-260",
                    title: "Westridge Medical",
                    status: "scheduled",
                    startTime: "11:22 AM",
                    endTime: "11:58 AM",
                    address: "91734 Eastcliff Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20619",
                    start: "2025-07-31T11:22:00+05:00",
                    end: "2025-07-31T11:58:00+05:00",
                    origin: {
                      lat: 32.74270897105405,
                      lng: -96.70594163276925,
                    },
                    drive_time: "9",
                    durationMinutes: 36,
                  },
                  {
                    id: "landscape_maintenance-visit-261",
                    title: "Park Haven Offices",
                    status: "scheduled",
                    startTime: "12:10 PM",
                    endTime: "12:35 PM",
                    address: "6712-6798 Overpark Ct, Dallas, TX",
                    contract: "Maintenance Agreement 20620",
                    start: "2025-07-31T12:10:00+05:00",
                    end: "2025-07-31T12:35:00+05:00",
                    origin: {
                      lat: 32.74158373926312,
                      lng: -96.70466253702625,
                    },
                    drive_time: "12",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-262",
                    title: "Villas at Preston",
                    status: "scheduled",
                    startTime: "12:46 PM",
                    endTime: "1:16 PM",
                    address: "7015 Petty Ln, Dallas, TX",
                    contract: "Maintenance Agreement 20621",
                    start: "2025-07-31T12:46:00+05:00",
                    end: "2025-07-31T13:16:00+05:00",
                    origin: {
                      lat: 32.744066518149474,
                      lng: -96.70195797501958,
                    },
                    drive_time: "11",
                    durationMinutes: 30,
                  },
                  {
                    id: "landscape_maintenance-visit-263",
                    title: "Creekside Townhomes",
                    status: "scheduled",
                    startTime: "1:29 PM",
                    endTime: "1:54 PM",
                    address: "7034 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20622",
                    start: "2025-07-31T13:29:00+05:00",
                    end: "2025-07-31T13:54:00+05:00",
                    origin: {
                      lat: 32.744552905644404,
                      lng: -96.7009760120773,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-264",
                    title: "Midway Business Hub",
                    status: "scheduled",
                    startTime: "2:01 PM",
                    endTime: "2:27 PM",
                    address: "76925 Tillman St, Dallas, TX",
                    contract: "Maintenance Agreement 20623",
                    start: "2025-07-31T14:01:00+05:00",
                    end: "2025-07-31T14:27:00+05:00",
                    origin: {
                      lat: 32.744964457415065,
                      lng: -96.7031389159949,
                    },
                    drive_time: "7",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-265",
                    title: "Sunset Terrace",
                    status: "scheduled",
                    startTime: "2:33 PM",
                    endTime: "2:58 PM",
                    address: "62036 Earnhardt Way, Dallas, TX",
                    contract: "Maintenance Agreement 20624",
                    start: "2025-07-31T14:33:00+05:00",
                    end: "2025-07-31T14:58:00+05:00",
                    origin: {
                      lat: 32.74774466169055,
                      lng: -96.70055250157739,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-266",
                    title: "The Oaks HOA",
                    status: "scheduled",
                    startTime: "3:05 PM",
                    endTime: "3:38 PM",
                    address: "77120 Clearpoint Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20625",
                    start: "2025-07-31T15:05:00+05:00",
                    end: "2025-07-31T15:38:00+05:00",
                    origin: {
                      lat: 32.746171539123075,
                      lng: -96.69917866641367,
                    },
                    drive_time: "7",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-267",
                    title: "Commerce Crossing",
                    status: "scheduled",
                    startTime: "3:48 PM",
                    endTime: "4:33 PM",
                    address: "101830 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20626",
                    start: "2025-07-31T15:48:00+05:00",
                    end: "2025-07-31T16:33:00+05:00",
                    origin: {
                      lat: 32.74388337540704,
                      lng: -96.69849674556865,
                    },
                    drive_time: "10",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-268",
                    title: "Bluffview Estates",
                    status: "scheduled",
                    startTime: "4:42 PM",
                    endTime: "5:07 PM",
                    address: "91726 Oldfield Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20627",
                    start: "2025-07-31T16:42:00+05:00",
                    end: "2025-07-31T17:07:00+05:00",
                    origin: {
                      lat: 32.742733797171546,
                      lng: -96.69850949814688,
                    },
                    drive_time: "9",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-269",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "5:07 PM",
                    endTime: "5:37 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-07-31T17:07:00+05:00",
                    end: "2025-07-31T17:37:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  {
    date: "2026-05-22",
    serviceLines: [
      {
        id: "landscape_maintenance",
        name: "Landscape maintenance",
        managers: [
          {
            id: "mgr-001",
            name: "John Ferris",
            phone: "+923001234567",
            crew: [
              {
                id: "crew-a-001",
                name: "LM 1",
                crew_leader: "Jake Ryan",
                hours: "30",
                crewMembers: [
                  {
                    id: "member-001",
                    name: "Jake Ryan",
                    image: "/images/dummy/crew1.png",
                    role: "5678, Crew leader",
                    punchedIn: "6:38 AM",
                    crewLeader: true,
                    crewLeaderId: "crew-22-001",
                  },
                  {
                    id: "member-002",
                    name: "Carlos Eduardo",
                    image: "/images/dummy/crew2.png",
                    latePunchedIn: "7:59 AM",
                    role: "5679",
                    crewLeaderId: "crew-22-002",
                  },
                  {
                    id: "member-003",
                    name: "Tyler James",
                    image: "/images/dummy/crew3.png",
                    punchedIn: "7:25 AM",
                    role: "1265",
                    crewLeaderId: "crew-22-003",
                  },
                  {
                    id: "member-004",
                    name: "Mateo Luis",
                    image: "/images/dummy/crew4.png",
                    role: "2904",
                    punchedIn: "6:38 AM",
                    crewLeaderId: "crew-22-004",
                  },
                ],

                visit: [
                  {
                    id: "landscape_maintenance-visit-270",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "7:00 AM",
                    endTime: "7:30 AM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T07:00:00+05:00",
                    end: "2025-08-01T07:30:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "10",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-home.svg",
                  },
                  {
                    id: "landscape_maintenance-visit-271",
                    title: "Laurel Park Commons",
                    status: "scheduled",
                    startTime: "7:37 AM",
                    endTime: "8:06 AM",
                    address: "72200 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20628",
                    start: "2025-08-01T07:37:00+05:00",
                    end: "2025-08-01T08:06:00+05:00",
                    origin: {
                      lat: 32.82700062143119,
                      lng: -96.97545355404942,
                    },
                    drive_time: "29",
                    durationMinutes: 29,
                  },
                  {
                    id: "landscape_maintenance-visit-272",
                    title: "Willowview HOA",
                    status: "scheduled",
                    startTime: "8:18 AM",
                    endTime: "8:44 AM",
                    address: "121603 Priscilla Ln, Irving, TX",
                    contract: "Maintenance Agreement 20629",
                    start: "2025-08-01T08:18:00+05:00",
                    end: "2025-08-01T08:44:00+05:00",
                    origin: {
                      lat: 32.83158778723434,
                      lng: -96.97103910479787,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-273",
                    title: "The Branch Offices",
                    status: "scheduled",
                    startTime: "8:52 AM",
                    endTime: "9:20 AM",
                    address: "81709 Green Oaks Dr, Irving, TX",
                    contract: "Maintenance Agreement 20630",
                    start: "2025-08-01T08:52:00+05:00",
                    end: "2025-08-01T09:20:00+05:00",
                    origin: {
                      lat: 32.832432887464925,
                      lng: -96.96678781110751,
                    },
                    drive_time: "28",
                    durationMinutes: 28,
                  },
                  {
                    id: "landscape_maintenance-visit-274",
                    title: "Fox Hill Plaza",
                    status: "scheduled",
                    startTime: "9:33 AM",
                    endTime: "10:06 AM",
                    address: "13267 W St Clair Dr, Irving, TX",
                    contract: "Maintenance Agreement 20631",
                    start: "2025-08-01T09:33:00+05:00",
                    end: "2025-08-01T10:06:00+05:00",
                    origin: {
                      lat: 32.82459779966745,
                      lng: -96.96212813072863,
                    },
                    drive_time: "33",
                    durationMinutes: 33,
                  },
                  {
                    id: "landscape_maintenance-visit-275",
                    title: "Northaven Suites",
                    status: "scheduled",
                    startTime: "10:13 AM",
                    endTime: "10:38 AM",
                    address: "71311 W Irving Blvd, Irving, TX",
                    contract: "Maintenance Agreement 20632",
                    start: "2025-08-01T10:13:00+05:00",
                    end: "2025-08-01T10:38:00+05:00",
                    origin: {
                      lat: 32.81738323907385,
                      lng: -96.96163571966576,
                    },
                    drive_time: "7",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-276",
                    title: "Springridge Center",
                    status: "scheduled",
                    startTime: "10:48 AM",
                    endTime: "11:15 AM",
                    address: "101309 Limetree Ln, Irving, TX",
                    contract: "Maintenance Agreement 20633",
                    start: "2025-08-01T10:48:00+05:00",
                    end: "2025-08-01T11:15:00+05:00",
                    origin: {
                      lat: 32.82658243688681,
                      lng: -96.95362221982374,
                    },
                    drive_time: "10",
                    durationMinutes: 27,
                  },
                  {
                    id: "landscape_maintenance-visit-277",
                    title: "Midpark Towers",
                    status: "scheduled",
                    startTime: "11:20 AM",
                    endTime: "12:05 PM",
                    address: "51118 Brady Dr, Irving, TX",
                    contract: "Maintenance Agreement 20634",
                    start: "2025-08-01T11:20:00+05:00",
                    end: "2025-08-01T12:05:00+05:00",
                    origin: {
                      lat: 32.82671809190914,
                      lng: -96.94998831806257,
                    },
                    drive_time: "45",
                    durationMinutes: 45,
                    workOrders: ["Weekly service"],
                  },
                  {
                    id: "landscape_maintenance-visit-278",
                    title: "Cottonwood Villas",
                    status: "scheduled",
                    startTime: "12:13 PM",
                    endTime: "12:39 PM",
                    address: "81946 Shoaf Dr, Irving, TX",
                    contract: "Maintenance Agreement 20635",
                    start: "2025-08-01T12:13:00+05:00",
                    end: "2025-08-01T12:39:00+05:00",
                    origin: {
                      lat: 32.83422926324008,
                      lng: -96.94588238382623,
                    },
                    drive_time: "26",
                    durationMinutes: 26,
                  },
                  {
                    id: "landscape_maintenance-visit-279",
                    title: "Valley Glen Retail",
                    status: "scheduled",
                    startTime: "12:45 PM",
                    endTime: "1:10 PM",
                    address: "62021 Shoaf Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20636",
                    start: "2025-08-01T12:45:00+05:00",
                    end: "2025-08-01T13:10:00+05:00",
                    origin: {
                      lat: 32.83518441521939,
                      lng: -96.94790165829477,
                    },
                    drive_time: "6",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-280",
                    title: "Hidden Creek Plaza",
                    status: "scheduled",
                    startTime: "1:23 PM",
                    endTime: "1:48 PM",
                    address: "13122 W Holland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20637",
                    start: "2025-08-01T13:23:00+05:00",
                    end: "2025-08-01T13:48:00+05:00",
                    origin: {
                      lat: 32.83841754739589,
                      lng: -96.94561778664372,
                    },
                    drive_time: "13",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-281",
                    title: "Ridgewood Shops",
                    status: "scheduled",
                    startTime: "1:55 PM",
                    endTime: "2:26 PM",
                    address: "72326 W Newton Cir, Dallas, TX",
                    contract: "Maintenance Agreement 20638",
                    start: "2025-08-01T13:55:00+05:00",
                    end: "2025-08-01T14:26:00+05:00",
                    origin: {
                      lat: 32.83931617496474,
                      lng: -96.94817451366447,
                    },
                    drive_time: "7",
                    durationMinutes: 31,
                  },
                  {
                    id: "landscape_maintenance-visit-282",
                    title: "Southside Gardens",
                    status: "scheduled",
                    startTime: "2:37 PM",
                    endTime: "3:02 PM",
                    address: "112328 Brockbank Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20639",
                    start: "2025-08-01T14:37:00+05:00",
                    end: "2025-08-01T15:02:00+05:00",
                    origin: {
                      lat: 32.83917228935476,
                      lng: -96.94994426998946,
                    },
                    drive_time: "11",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-283",
                    title: "The Gables at Oak",
                    status: "scheduled",
                    startTime: "3:16 PM",
                    endTime: "3:41 PM",
                    address: "14120 E Scotland Dr, Dallas, TX",
                    contract: "Maintenance Agreement 20640",
                    start: "2025-08-01T15:16:00+05:00",
                    end: "2025-08-01T15:41:00+05:00",
                    origin: {
                      lat: 32.840372057900865,
                      lng: -96.94357860432224,
                    },
                    drive_time: "14",
                    durationMinutes: 25,
                  },
                  {
                    id: "landscape_maintenance-visit-284",
                    title: "North Cliff Commons",
                    status: "scheduled",
                    startTime: "3:49 PM",
                    endTime: "4:36 PM",
                    address: "81403 English St, Dallas, TX",
                    contract: "Maintenance Agreement 20641",
                    start: "2025-08-01T15:49:00+05:00",
                    end: "2025-08-01T16:36:00+05:00",
                    origin: {
                      lat: 32.828681781644484,
                      lng: -96.93769216199404,
                    },
                    drive_time: "47",
                    durationMinutes: 47,
                  },
                  {
                    id: "landscape_maintenance-visit-285",
                    title: "Evergreen's Yard",
                    status: "scheduled",
                    startTime: "4:36 PM",
                    endTime: "5:06 PM",
                    address: "8636 Forest Green Dr, Dallas, TX",
                    contract: "",
                    start: "2025-08-01T16:36:00+05:00",
                    end: "2025-08-01T17:06:00+05:00",
                    origin: {
                      lat: 32.908507182894425,
                      lng: -96.75332537733318,
                    },
                    drive_time: "0",
                    durationMinutes: 30,
                    homeIcon: "/images/schedule/icon-crew-yard.svg",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const INITIAL_UNSCHEDULED_TASKS_DATA = [
  {
    id: "task-001",
    title: "Pruning",
    location: "Ridgehill Business Plaza",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Landscape maintenance",
  },
  // {
  //   id: "task-002",
  //   title: "Mulching",
  //   location: "Wyatt Coleman's Residence",
  //   durationHours: 0.5,
  //   origin: {
  //     lat: 32.8023157,
  //     lng: -96.7915574,
  //   },
  //   description: "Lawn care",
  // },
  {
    id: "task-003",
    title: "Mulching",
    location: "Zoltrix Corporate Center",
    durationHours: 0.4,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Construction",
  },
  {
    id: "task-004",
    title: "Seasonal color maintenance",
    location: "Maple Grove Offices",
    durationHours: 0.45,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  {
    id: "task-005",
    title: "Pruning",
    location: "Logan Bennett's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8101416,
      lng: -96.8488331,
    },
    description: "Construction",
  },
  {
    id: "task-006",
    title: "Mulching",
    location: "Trevor James's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7481358,
      lng: -96.8475267,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-007",
    title: "Mechanical trenching",
    location: "Nextrix Auto Works",
    durationHours: 0.5,
    origin: {
      lat: 32.7936166,
      lng: -96.7268803,
    },
    description: "Lawn care",
  },
  {
    id: "task-008",
    title: "Seasonal color maintenance",
    location: "Nolan Reed's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8139785,
      lng: -96.8665971,
    },
    description: "Lawn care",
  },
  {
    id: "task-009",
    title: "Mulching",
    location: "Drofina Consulting",
    durationHours: 0.5,
    origin: {
      lat: 32.8765432,
      lng: -96.7532109,
    },
    description: "Lawn care",
  },
  {
    id: "task-010",
    title: "Pruning",
    location: "Blake Anderson's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.9095697,
      lng: -96.8052161,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-011",
    title: "Site preparation",
    location: "Ryan Cooper's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.9348931,
      lng: -96.7820464,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-012",
    title: "Pruning",
    location: "Nolan Reed's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8454235,
      lng: -96.7578901,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-013",
    title: "Mechanical trenching",
    location: "Christopher Adams's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  // {
  //   id: "task-014",
  //   title: "Mulching",
  //   location: "Zoltrix Corporate Center",
  //   durationHours: 0.5,
  //   origin: {
  //     lat: 32.8858971,
  //     lng: -96.8647038,
  //   },
  //   description: "Construction",
  // },
  {
    id: "task-015",
    title: "Softscape installation",
    location: "Maxwell Grant's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  // {
  //   id: "task-016",
  //   title: "Mulching",
  //   location: "Ethan Walker's Residence",
  //   durationHours: 0.5,
  //   origin: {
  //     lat: 32.7663459,
  //     lng: -96.7915574,
  //   },
  //   description: "Lawn care",
  // },
  {
    id: "task-017",
    title: "Mulching",
    location: "Ryan Cooper's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Construction",
  },
  {
    id: "task-018",
    title: "Mechanical trenching",
    location: "Harnix Logistics Center",
    durationHours: 0.4,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Construction",
  },
  {
    id: "task-019",
    title: "Site preparation",
    location: "Logan Bennett's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-020",
    title: "Seasonal color maintenance",
    location: "Austin Parker's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  // {
  //   id: "task-021",
  //   title: "Mulching",
  //   location: "Flornex Consulting",
  //   durationHours: 0.5,
  //   origin: {
  //     lat: 32.899318,
  //     lng: -96.7445763,
  //   },
  //   description: "Construction",
  // },
  {
    id: "task-022",
    title: "Inspection / Wet check",
    location: "Caleb Morris's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Irrigation",
  },
  {
    id: "task-023",
    title: "Pruning",
    location: "Derrick Coleman's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-024",
    title: "Seasonal color maintenance",
    location: "Nolan Reed's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-025",
    title: "Mechanical trenching",
    location: "Nextrix Auto Works",
    durationHours: 0.4,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Lawn care",
  },
  {
    id: "task-026",
    title: "Mulching",
    location: "Logan Bennett's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Lawn care",
  },
  {
    id: "task-027",
    title: "Pruning",
    location: "Orvanta Business Complex",
    durationHours: 0.4,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  {
    id: "task-028",
    title: "Site preparation",
    location: "Vantrex Works",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-029",
    title: "Inspection / Wet check",
    location: "Santiago Hernandez's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Lawn care",
  },
  {
    id: "task-030",
    title: "Mechanical trenching",
    location: "Shawn Bennett's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Construction",
  },
  {
    id: "task-031",
    title: "Site preparation",
    location: "Zachary Reed's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-032",
    title: "Mechanical trenching",
    location: "Willow Creek Reserve",
    durationHours: 0.4,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-033",
    title: "Inspection / Wet check",
    location: "Trevor James's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Lawn care",
  },
  {
    id: "task-034",
    title: "Pruning",
    location: "Quorlen Global",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-035",
    title: "Mechanical trenching",
    location: "Caleb Morris's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-036",
    title: "Mulching",
    location: "Bristiq Tools & Supply Center",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-037",
    title: "Inspection / Wet check",
    location: "Maple Grove Offices",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Irrigation",
  },
  {
    id: "task-038",
    title: "Site preparation",
    location: "Nolan Reed's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Lawn care",
  },
  {
    id: "task-039",
    title: "Inspection / Wet check",
    location: "Grayson Bennett's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-040",
    title: "Mulching",
    location: "Henry Adams's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-041",
    title: "Seasonal color maintenance",
    location: "Ethan Walker's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Construction",
  },
  {
    id: "task-042",
    title: "Inspection / Wet check",
    location: "Mason Hayes's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Construction",
  },
  {
    id: "task-043",
    title: "Softscape installation",
    location: "Henry Adams's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-044",
    title: "Pruning",
    location: "Orvanta Business Complex",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  {
    id: "task-045",
    title: "Seasonal color maintenance",
    location: "Moventa Steel Corp",
    durationHours: 0.4,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-046",
    title: "Mulching",
    location: "Bennett Lawson's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Irrigation",
  },
  {
    id: "task-047",
    title: "Softscape installation",
    location: "Nextrix Auto Works",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  {
    id: "task-048",
    title: "Seasonal color maintenance",
    location: "Brandon Hayes's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-049",
    title: "Softscape installation",
    location: "Miles Hamilton's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Landscape maintenance",
  },
  // {
  //   id: "task-050",
  //   title: "Softscape installation",
  //   location: "Prallax Design Lab",
  //   durationHours: 0.4,
  //   origin: {
  //     lat: 32.8858971,
  //     lng: -96.8647038,
  //   },
  //   description: "Lawn care",
  // },
  {
    id: "task-051",
    title: "Pruning",
    location: "Nolan Reed's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  // {
  //   id: "task-052",
  //   title: "Softscape installation",
  //   location: "Blake Anderson's Residence",
  //   durationHours: 0.4,
  //   origin: {
  //     lat: 32.7663459,
  //     lng: -96.7915574,
  //   },
  //   description: "Lawn care",
  // },
  {
    id: "task-053",
    title: "Mulching",
    location: "Parkway Executive Suites",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-054",
    title: "Inspection / Wet check",
    location: "Austin Parker's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-055",
    title: "Site preparation",
    location: "Jason Miller's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  {
    id: "task-056",
    title: "Softscape installation",
    location: "Ryan Cooper's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  {
    id: "task-057",
    title: "Mulching",
    location: "Maple Grove Offices",
    durationHours: 0.4,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Irrigation",
  },
  {
    id: "task-058",
    title: "Pruning",
    location: "Logan Bennett's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-059",
    title: "Mechanical trenching",
    location: "Tybrin Distribution Center",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-060",
    title: "Softscape installation",
    location: "Declan Foster's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-061",
    title: "Pruning",
    location: "Connor Mitchell's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Irrigation",
  },
  {
    id: "task-062",
    title: "Site preparation",
    location: "Drofina Consulting",
    durationHours: 0.4,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Lawn care",
  },
  {
    id: "task-063",
    title: "Seasonal color maintenance",
    location: "Wyatt Coleman's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-064",
    title: "Softscape installation",
    location: "Parkway Executive Suites",
    durationHours: 0.4,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-065",
    title: "Inspection / Wet check",
    location: "Maxwell Grant's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Irrigation",
  },
  {
    id: "task-066",
    title: "Seasonal color maintenance",
    location: "Moventa Steel Corp",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Construction",
  },
  {
    id: "task-067",
    title: "Mechanical trenching",
    location: "Wyatt Coleman's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-068",
    title: "Pruning",
    location: "Ryan Cooper's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-069",
    title: "Mechanical trenching",
    location: "Bravlon Companys",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Irrigation",
  },
  {
    id: "task-070",
    title: "Inspection / Wet check",
    location: "Torvyn Tech Group",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-071",
    title: "Pruning",
    location: "Orvanta Business Complex",
    durationHours: 0.4,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Construction",
  },
  {
    id: "task-072",
    title: "Seasonal color maintenance",
    location: "Logan Bennett's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-073",
    title: "Mechanical trenching",
    location: "Ethan Walker's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Lawn care",
  },
  {
    id: "task-074",
    title: "Softscape installation",
    location: "Volnera Summit Park",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-075",
    title: "Inspection / Wet check",
    location: "Tiffany Williams's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-076",
    title: "Pruning",
    location: "Nexuvo Office Tower",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-077",
    title: "Mechanical trenching",
    location: "Breylin Property Group",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Construction",
  },
  // {
  //   id: "task-078",
  //   title: "Mulching",
  //   location: "Ryan Cooper's Residence",
  //   durationHours: 0.4,
  //   origin: {
  //     lat: 32.8858971,
  //     lng: -96.8647038,
  //   },
  //   description: "Landscape maintenance",
  // },
  {
    id: "task-079",
    title: "Site preparation",
    location: "Trevor James's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-080",
    title: "Mulching",
    location: "Caleb Morris's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  // {
  //   id: "task-081",
  //   title: "Mulching",
  //   location: "Prallax Design Lab",
  //   durationHours: 0.5,
  //   origin: {
  //     lat: 32.899318,
  //     lng: -96.7445763,
  //   },
  //   description: "Construction",
  // },
  {
    id: "task-082",
    title: "Inspection / Wet check",
    location: "Feltrix Business Plaza",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-083",
    title: "Mulching",
    location: "Gavin Scott's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8023157,
      lng: -96.7915574,
    },
    description: "Irrigation",
  },
  {
    id: "task-084",
    title: "Pruning",
    location: "Nolan Reed's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Landscape maintenance",
  },
  // {
  //   id: "task-085",
  //   title: "Mulching",
  //   location: "Dylan Carter's Residence",
  //   durationHours: 0.4,
  //   origin: {
  //     lat: 32.899318,
  //     lng: -96.7445763,
  //   },
  //   description: "Landscape maintenance",
  // },
  {
    id: "task-086",
    title: "Seasonal color maintenance",
    location: "Easton Ward's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Irrigation",
  },
  // {
  //   id: "task-087",
  //   title: "Mulching",
  //   location: "Drofina Consulting",
  //   durationHours: 0.5,
  //   origin: {
  //     lat: 32.8023157,
  //     lng: -96.7915574,
  //   },
  //   description: "Irrigation",
  // },
  {
    id: "task-088",
    title: "Inspection / Wet check",
    location: "Lincoln Perry's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.7663459,
      lng: -96.7915574,
    },
    description: "Lawn care",
  },
  {
    id: "task-089",
    title: "Pruning",
    location: "Derrick Coleman's Residence",
    durationHours: 0.5,
    origin: {
      lat: 32.899318,
      lng: -96.7445763,
    },
    description: "Landscape maintenance",
  },
  {
    id: "task-090",
    title: "Seasonal color maintenance",
    location: "Nolan Reed's Residence",
    durationHours: 0.4,
    origin: {
      lat: 32.8858971,
      lng: -96.8647038,
    },
    description: "Lawn care",
  },
];
